import styled from '@emotion/styled';

import Card from '@mui/material/Card';

export const StyledCard = styled(Card)`
  max-width: 800px;
  padding: 0 54px 16px 54px;
  margin: 24px;
`;
